export const cardListInit = () => {
    document.querySelectorAll('.js-development-list-wrapper')?.forEach((wrapper) => {
        const list = wrapper.querySelector('.js-development-list')
        const items = [...wrapper.querySelectorAll('.js-development-list-item')]
        const total = items.length
        const perPage = parseInt(wrapper.dataset.perPage, 10) || 4
        const button = wrapper.parentElement.querySelector('.js-development-list-button')
        const label = button?.querySelector('.js-development-list-label')

        if (!list || total <= perPage) {
            button?.classList.add('hidden')
            return
        }

        let visibleCount = Math.min(perPage, total)

        const updateView = () => {
            const gap = parseFloat(getComputedStyle(list).rowGap) || 0
            let height = 0

            items.forEach((item, index) => {
                const isVisible = index < visibleCount
                item.style.opacity = isVisible ? '' : '0.4'
                item.inert = !isVisible

                if (index < visibleCount) {
                    height += item.offsetHeight + (index > 0 ? gap : 0)
                } else if (index === visibleCount) {
                    // Reveal a peek of the next item below the fold.
                    height += gap + item.offsetHeight * 0.25
                }
            })

            wrapper.style.maxHeight = `${height}px`

            const remaining = total - visibleCount
            if (remaining <= 0) {
                button.classList.add('hidden')
                return
            }

            const nextBatch = Math.min(perPage, remaining)
            const nextVisible = Math.min(visibleCount + perPage, total)
            if (label) {
                label.textContent = `Show ${nextBatch} more development${nextBatch === 1 ? '' : 's'} (${nextVisible}/${total})`
            }
        }

        button?.addEventListener('click', () => {
            visibleCount = Math.min(visibleCount + perPage, total)
            updateView()
        })

        wrapper.style.transition = 'max-height 300ms ease'
        updateView()

        // Card heights change on resize (reflow/breakpoint changes), so the
        // max-height needs recalculating. ResizeObserver only watches the
        // items themselves (not the wrapper, whose height we're the one
        // setting) so this doesn't trigger itself, and batching via
        // requestAnimationFrame coalesces bursts of callbacks into one
        // recalculation per frame instead of thrashing layout on every tick.
        let resizeFrame = null
        const resizeObserver = new ResizeObserver(() => {
            if (resizeFrame) return
            resizeFrame = requestAnimationFrame(() => {
                resizeFrame = null
                updateView()
            })
        })
        items.forEach((item) => resizeObserver.observe(item))
    })
}

cardListInit()
